/**
 * BookMyYogaTTC platform operator details (login / claim left panel).
 */
export const PLATFORM_BRAND_NAME = 'bookmyyogattc'

export const PLATFORM_BUSINESS = {
  /** Name of enterprise (Udyam certificate) */
  enterpriseName: 'BOOKMYYOGATTC',
  legalName: 'BOOKMYYOGATTC',
  udyamNumber: 'UDYAM-UK-05-0122133',
  /** As on Udyam certificate (DD/MM/YYYY) */
  udyamRegistrationDate: '09/01/2026',
  businessRegNumber: '',
  gstNumber: '',
  registeredAddress: '',
  contactEmail: 'info@bookmyyogattc.com',
} as const

export const PLATFORM_HAS_UDYAM = Boolean(PLATFORM_BUSINESS.udyamNumber)

export const PLATFORM_HAS_REGISTRATION_DETAILS =
  Boolean(PLATFORM_BUSINESS.businessRegNumber) ||
  Boolean(PLATFORM_BUSINESS.gstNumber) ||
  PLATFORM_HAS_UDYAM ||
  Boolean(PLATFORM_BUSINESS.registeredAddress)
